import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { HttpService } from 'src/app/services/http.service';

@AutoUnsubscribe()
@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit, OnDestroy {

  constructor(
    private route: ActivatedRoute,
    private http: HttpService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (params.applicationKey) {
        this.form.controls.applicationKey.setValue(params.applicationKey);
        this.getUser(params.applicationKey);
      }

      if (params.code) {
        this.getMessage(params.code);
      }
    });
  }

  public sent = false;
  public extra!: string;

  public form = new FormGroup({
    name: new FormControl(null, [Validators.required]),
    emailAddress: new FormControl(null, [Validators.required, Validators.email]),
    message: new FormControl(null, [Validators.required]),
    applicationKey: new FormControl(null),
  });

  async ngSubmit(form: FormGroup)  {
    if (form.valid) {
      form.disable();

      var template: any = await this.http.template();
      template = decodeURIComponent(template.content);

      template = (template as String).replace('[CUSTOMER_NAME]', form.value.name)
      template = (template as String).replace('[CUSTOMER_EMAIL]', form.value.emailAddress)
      template = (template as String).replace('[REASON]', `Feedback${(form.value.applicationKey ? ` (${form.value.applicationKey})` : '')}`)
      template = (template as String).replace('[MESSAGE]', form.value.message)

      // Send feedback
      await this.http.feedback({
        to: 'support@zeropay.co.za',
        cc: 'ashton@fevertreefinance.co.za;radhiyah@fevertreefinance.co.za',
        bcc: 'tristan@fevertreefinance.co.za',
        subject: 'ZeroPay Feedback',
        body: template,
      });

      setTimeout(() => {
        this.sent = true;
      });
    }
  }

  async getMessage(code: String) {
    var template: any = await this.http.templateGet(code);
    template = decodeURIComponent(template.content);
    this.extra = template;
  }

  async getUser(code: String) {
    var user: any = await this.http.user(code);

    if (user) {

      if (user.emailAddress) {
        this.form.controls.emailAddress.setValue(user.emailAddress);
        this.form.controls.emailAddress.disable();
      }

      if (user.firstname) {
        this.form.controls.name.setValue(`${user.firstname} ${user.lastname}`);
        this.form.controls.name.disable();
      }
    }

    this.form.updateValueAndValidity();
  }

  ngOnDestroy(): void {}
}
